/* eslint eqeqeq: 0 */

import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import AddLocation from "./AddLocation"
import EditLocation from "./EditLocation"
import LocationList from "./LocationList"

 class Index extends Component {
   constructor(props) {
     super(props);
     this.state = {
       routeStatus: 0,
       dataValue: {},
     };
   }

   changeStatus = (type) => {
     this.setState({
       routeStatus: type,
     });
   };

   changeStatusWithStatusValue = (type, dataValue) => {
     this.setState({
       routeStatus: type,
       dataValue,
     });
   };

   render() {
     const { routeStatus, dataValue } = this.state;
     return (
       <div className="wrapper position-relative">
         {routeStatus == 0 && (
           <LocationList
             changeStatusWithStatusValue={this.changeStatusWithStatusValue}
           />
         )}

         {routeStatus == 1 && <AddLocation changeRouteStatus={this.changeStatus} />}

         {routeStatus == 2 && (
           <EditLocation changeRouteStatus={this.changeStatus} item={dataValue} />
         )}
       </div>
     );
   }
 }
export default (withRouter(Index));